module.exports = __webpack_public_path__ + "static/media/new-version.105b2f2c.svg";